import * as types from '../constants/action-types';
import Contracts from '../../../../api/api-contracts';

export function offerQuoteCreateRequest () {
  return {
    type: types.OFFER_QUOTE_CREATE_REQUEST
  };
}

export function offerQuoteCreateSuccess (response) {
  return {
    type: types.OFFER_QUOTE_CREATE_SUCCESS,
    response
  };
}

export function offerCreateRequest (isPosting) {
  return {
    type: types.OFFER_CREATE_REQUEST,
    isPosting
  };
}

export function offerCreateSuccess (response) {
  return {
    type: types.OFFER_CREATE_SUCCESS,
    response
  };
}

export function offerCreateFailure () {
  return {
    type: types.OFFER_CREATE_FAILURE
  };
}

export function offerWithdrawRequest (isPosting) {
  return {
    type: types.OFFER_WITHDRAW_REQUEST,
    isPosting
  };
}

export function offerAcceptRequest (isPosting) {
  return {
    type: types.OFFER_ACCEPT_REQUEST,
    isPosting
  };
}

export function offerDeclineRequest (isPosting) {
  return {
    type: types.OFFER_DECLINE_REQUEST,
    isPosting
  };
}

export function contractsFetchRequest (isFetching) {
  return {
    type: types.CONTRACTS_FETCH_REQUEST,
    isFetching
  };
}

export function hostUpdateQuoteRequest (isFetching) {
  return {
    type: types.HOST_UPDATE_QUOTE_REQUEST,
    isFetching
  };
}

export function hostUpdateQuoteSuccess (data) {
  return {
    type: types.HOST_UPDATE_QUOTE_SUCCESS,
    data
  };
}

export function createHostUpdateRequest (isPosting) {
  return {
    type: types.HOST_UPDATE_CREATE_REQUEST,
    isPosting
  };
}

export function createHostUpdateSuccess (response) {
  return {
    type: types.HOST_UPDATE_CREATE_SUCCESS,
    response
  };
}

export function createHostUpdateFailure () {
  return {
    type: types.HOST_UPDATE_CREATE_FAILURE
  };
}

export function hostUpdateDeclineRequest (isPosting) {
  return {
    type: types.HOST_UPDATE_DECLINE_REQUEST,
    isPosting
  };
}

export function hostUpdateAcceptRequest (isPosting) {
  return {
    type: types.HOST_UPDATE_ACCEPT_REQUEST,
    isPosting
  };
}

export function fetchContractsSnapshotRequest (isFetching) {
  return {
    type: types.CONTRACTS_SNAPSHOT_FETCH_REQUEST,
    isFetching
  };
}

export function fetchContractsSnapshotSuccess (data) {
  return {
    type: types.CONTRACTS_SNAPSHOT_FETCH_SUCCESS,
    data
  };
}

export function guestUpdateQuoteRequest (isPosting) {
  return {
    type: types.GUEST_UPDATE_QUOTE_REQUEST,
    isPosting
  };
}

export function guestUpdateQuoteSuccess (data) {
  return {
    type: types.GUEST_UPDATE_QUOTE_SUCCESS,
    data
  };
}

export function guestUpdateQuoteFailure (error) {
  return {
    type: types.GUEST_UPDATE_QUOTE_FAILURE,
    error
  };
}

export function createGuestUpdateRequest (isPosting) {
  return {
    type: types.GUEST_UPDATE_CREATE_REQUEST,
    isPosting
  };
}

export function createGuestUpdateSuccess (data) {
  return {
    type: types.GUEST_UPDATE_CREATE_SUCCESS,
    data
  };
}

export function createGuestUpdateFailure (error) {
  return {
    type: types.GUEST_UPDATE_CREATE_FAILURE,
    error
  };
}

export function acceptGuestUpdateRequest (isPosting) {
  return {
    type: types.GUEST_UPDATE_ACCEPT_REQUEST,
    isPosting
  };
}

export function acceptGuestUpdateSuccess (data) {
  return {
    type: types.GUEST_UPDATE_ACCEPT_SUCCESS,
    data
  };
}

export function acceptGuestUpdateFailure (error) {
  return {
    type: types.GUEST_UPDATE_ACCEPT_SUCCESS,
    error
  };
}

export function withdrawGuestUpdateRequest (isPosting) {
  return {
    type: types.GUEST_UPDATE_WITHDRAW_REQUEST,
    isPosting
  };
}

export function withdrawGuestUpdateSuccess (data) {
  return {
    type: types.GUEST_UPDATE_WITHDRAW_SUCCESS,
    data
  };
}

export function withdrawGuestUpdateFailure (error) {
  return {
    type: types.GUEST_UPDATE_WITHDRAW_FAILURE,
    error
  };
}

export function cancelBookingQuoteRequest (isPosting) {
  return {
    type: types.CANCEL_BOOKING_QUOTE_REQUEST,
    isPosting
  };
}

export function cancelBookingQuoteSuccess (data) {
  return {
    type: types.CANCEL_BOOKING_QUOTE_SUCCESS,
    data
  };
}

export function cancelBookingQuoteFailure (error) {
  return {
    type: types.CANCEL_BOOKING_QUOTE_FAILURE,
    error
  };
}

export function fetchCancellationContractsRequest (isPosting) {
  return {
    type: types.FETCH_CANCELLATION_CONTRACTS_REQUEST,
    isPosting
  };
}

export function fetchCancellationContractsSuccess (data) {
  return {
    type: types.FETCH_CANCELLATION_CONTRACTS_SUCCESS,
    data
  };
}

export function fetchCancellationContractsFailure (error) {
  return {
    type: types.FETCH_CANCELLATION_CONTRACTS_FAILURE,
    error
  };
}

export function overtimeQuoteRequest (isFetching) {
  return {
    type: types.OVERTIME_QUOTE_REQUEST,
    isFetching
  };
}

export function overtimeQuoteSuccess (data) {
  return {
    type: types.OVERTIME_QUOTE_SUCCESS,
    data
  };
}

export function overtimeQuoteFailure (data) {
  return {
    type: types.OVERTIME_QUOTE_FAILURE,
    data
  };
}

export function createOvertimeRequest (isPosting) {
  return {
    type: types.CREATE_OVERTIME_REQUEST,
    isPosting
  };
}

export function createOvertimeSuccess (response) {
  return {
    type: types.CREATE_OVERTIME_SUCCESS,
    response
  };
}

export function createOvertimeFailure () {
  return {
    type: types.CREATE_OVERTIME_FAILURE
  };
}

export function resetContractStore () {
  return {
    type: types.RESET_CONTRACT_STORE
  };
}

export function createOfferQuote (payload, token, callback) {
  return dispatch => {
    dispatch({ type: types.OFFER_QUOTE_CREATE_REQUEST });

    Contracts.createOfferQuote(payload, token, (response) => {
      if (response.error) {
        return dispatch({
          type: types.OFFER_QUOTE_CREATE_FAILURE,
          error: 'Something went wrong, please try again.'
        });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.OFFER_QUOTE_CREATE_SUCCESS,
        data: response
      });
    });
  };
}

export function createOffer (payload, token, callback) {
  return dispatch => {
    dispatch(offerCreateRequest(true));

    Contracts.createOffer(payload, token, (response) => {
      dispatch(offerCreateRequest(false));

      if (response.error) {
        return dispatch({
          type: types.OFFER_CREATE_FAILURE,
          error: true
        });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.OFFER_CREATE_SUCCESS,
        data: response
      });
    });
  };
}

export function withdrawOffer (controlId, payload, token, callback) {
  return dispatch => {
    dispatch(offerWithdrawRequest(true));

    Contracts.withdrawOffer(controlId, payload, token, (response) => {
      dispatch(offerWithdrawRequest(false));

      if (response.error) {
        if (callback) {
          callback(response);
        }
        return dispatch({ type: types.OFFER_WITHDRAW_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({ type: types.OFFER_WITHDRAW_SUCCESS });
    });
  };
}

export function acceptOffer (payload, controlId, token, callback, billingAddressPayload) {
  return dispatch => {
    dispatch(offerAcceptRequest(true));

    Contracts.acceptOffer(payload, controlId, token, response => {
      dispatch(offerAcceptRequest(false));
      if (response.error) {
        return dispatch({ type: types.OFFER_ACCEPT_FAILURE });
      }

      if (callback) {
        // acceptOfferCb in submitReviewOfferForm.js
        callback(response, billingAddressPayload);
      }

      return dispatch({ type: types.OFFER_ACCEPT_SUCCESS });
    });
  };
}

export function declineOffer (payload, controlId, token, callback) {
  return dispatch => {
    dispatch(offerDeclineRequest(true));

    Contracts.declineOffer(payload, controlId, token, response => {
      dispatch(offerDeclineRequest(false));
      if (response.error) {
        return dispatch({ type: types.OFFER_DECLINE_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({ type: types.OFFER_DECLINE_SUCCESS });
    });
  };
}

export function fetchContracts (bookingId, token, callback) {
  return dispatch => {
    dispatch(contractsFetchRequest(true));

    Contracts.readContracts(bookingId, token, (response) => {
      dispatch(contractsFetchRequest(false));

      if (response.error) {
        return dispatch({ type: types.CONTRACTS_FETCH_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.CONTRACTS_FETCH_SUCCESS,
        data: response
      });
    });
  };
}

export function hostUpdateQuote (payload, controlId, token, callback) {
  return dispatch => {
    dispatch(hostUpdateQuoteRequest(true));

    Contracts.hostUpdateQuote(payload, controlId, token, (response) => {
      dispatch(hostUpdateQuoteRequest(false));

      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch({
          type: types.HOST_UPDATE_QUOTE_FAILURE,
          error: 'Something went wrong, please try again.'
        });
      }

      return dispatch(hostUpdateQuoteSuccess(response.pending));
    });
  };
}

export function createHostUpdate (payload, controlId, token, callback) {
  return dispatch => {
    dispatch(createHostUpdateRequest(true));

    Contracts.createHostUpdate(payload, controlId, token, (response) => {
      dispatch(createHostUpdateRequest(false));

      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch(createHostUpdateFailure(response));
      }

      return dispatch(createHostUpdateSuccess());
    });
  };
}

export function declineHostUpdate (payload, controlId, token, callback) {
  return dispatch => {
    dispatch(hostUpdateDeclineRequest(true));

    Contracts.declineHostUpdate(payload, controlId, token, response => {
      dispatch(hostUpdateDeclineRequest(false));
      if (response.error) {
        return dispatch({ type: types.HOST_UPDATE_DECLINE_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({ type: types.HOST_UPDATE_DECLINE_SUCCESS });
    });
  };
}

export function acceptHostUpdate (payload, controlId, token, callback, billingAddressPayload) {
  return dispatch => {
    dispatch(hostUpdateAcceptRequest(true));

    Contracts.acceptHostUpdate(payload, controlId, token, response => {
      dispatch(hostUpdateAcceptRequest(false));
      if (response.error) {
        return dispatch({ type: types.HOST_UPDATE_ACCEPT_FAILURE });
      }

      if (callback) {
        // acceptOfferCb in submitReviewOfferForm.js
        callback(response, billingAddressPayload);
      }

      return dispatch({ type: types.HOST_UPDATE_ACCEPT_SUCCESS });
    });
  };
}

export function fetchContractsSnapshot (controlId, token, callback) {
  return dispatch => {
    dispatch(fetchContractsSnapshotRequest(true));

    Contracts.readContractsSnapshot(controlId, token, (response) => {
      dispatch(fetchContractsSnapshotRequest(false));

      if (response.error) {
        return dispatch({ type: types.CONTRACTS_SNAPSHOT_FETCH_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch(fetchContractsSnapshotSuccess(response));
    });
  };
}

export function guestUpdateQuote (payload, controlId, token, callback) {
  return dispatch => {
    dispatch(guestUpdateQuoteRequest(true));

    Contracts.guestUpdateQuote(payload, controlId, token, response => {
      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch(guestUpdateQuoteFailure(response.error));
      }

      return dispatch(guestUpdateQuoteSuccess(response));
    });
  };
}

export function createGuestUpdate (payload, controlId, token, callback) {
  return dispatch => {
    dispatch(createGuestUpdateRequest(true));

    Contracts.createGuestUpdate(payload, controlId, token, response => {
      dispatch(createGuestUpdateRequest(false));

      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch(createGuestUpdateFailure(response.error));
      }

      return dispatch(createGuestUpdateSuccess(response));
    });
  };
}

export function acceptGuestUpdate (controlId, token, callback) {
  return dispatch => {
    dispatch(acceptGuestUpdateRequest(true));

    Contracts.updateGuestUpdate({}, controlId, token, 'accept', response => {
      dispatch(acceptGuestUpdateRequest(false));

      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch(acceptGuestUpdateFailure(response.error));
      }

      return dispatch(acceptGuestUpdateSuccess(response));
    });
  };
}

export function withdrawGuestUpdate (payload, controlId, token, callback) {
  return dispatch => {
    dispatch(withdrawGuestUpdateRequest(true));

    Contracts.updateGuestUpdate(payload, controlId, token, 'withdraw', response => {
      if (response.error) {
        return dispatch(withdrawGuestUpdateFailure(response.error));
      }

      if (callback) {
        callback(response);
      }

      return dispatch(withdrawGuestUpdateSuccess(response));
    });
  };
}

export function cancelBookingQuote (payload, controlId, token, callback) {
  return dispatch => {
    dispatch(cancelBookingQuoteRequest(true));

    Contracts.cancelBookingContractQuote(payload, controlId, token, response => {
      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch(cancelBookingQuoteFailure(response.error));
      }

      return dispatch(cancelBookingQuoteSuccess(response));
    });
  };
}

export function fetchCancellationContracts (controlId, token, callback) {
  return dispatch => {
    dispatch(fetchCancellationContractsRequest(true));

    Contracts.readContractCancellation(controlId, token, response => {
      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch(fetchCancellationContractsFailure(response.error));
      }

      return dispatch(fetchCancellationContractsSuccess(response));
    });
  };
}

export function overtimeQuote (payload, controlId, token, callback) {
  return dispatch => {
    dispatch(overtimeQuoteRequest(true));

    Contracts.overtimeQuote(payload, controlId, token, (response) => {
      dispatch(overtimeQuoteRequest(false));

      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch(overtimeQuoteFailure(response));
      }

      return dispatch(overtimeQuoteSuccess(response.pending));
    });
  };
}

export function createOvertime (payload, controlId, token, callback) {
  return dispatch => {
    dispatch(createOvertimeRequest(true));

    Contracts.createOvertime(payload, controlId, token, (response) => {
      dispatch(createOvertimeRequest(false));

      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch(createOvertimeFailure(response));
      }

      return dispatch(createOvertimeSuccess());
    });
  };
}
